// Deutsche Anzeige-Labels, Symbole und Farbklassen für Changelog-Einträge.
// Gemeinsam genutzt von der Tabelle (ChangelogPage) und dem Detailfenster
// (ChangelogDetailDialog), damit beide dieselben Begriffe zeigen.

import type { ChangelogEntry } from "@/types/changelog";

/** Farbklassen des Diff-Schemas (cl-badge-*, cl-chip-*). */
export type DiffTone = "added" | "removed" | "modified" | "neutral";

export const TYPE_TONE: Record<string, DiffTone> = {
  added: "added",
  pruefid_added: "added",
  removed: "removed",
  pruefid_removed: "removed",
  modified: "modified",
  version_bump: "modified",
  unknown: "neutral",
};

export const TYPE_SYM: Record<string, string> = {
  added: "+",
  pruefid_added: "+",
  removed: "−",
  pruefid_removed: "−",
  modified: "~",
  version_bump: "↑",
  equal: "=",
  unknown: "·",
};

export const TYPE_LABEL: Record<string, string> = {
  added: "Hinzugefügt",
  pruefid_added: "Prüfi neu",
  removed: "Entfernt",
  pruefid_removed: "Prüfi weg",
  modified: "Geändert",
  version_bump: "Version",
  equal: "Gleich",
  unknown: "Unklar",
};

/** Feste Anzeige-Reihenfolge für Chips und Typ-Filter. */
export const TYPE_ORDER = [
  "equal",
  "added",
  "removed",
  "modified",
  "version_bump",
  "pruefid_added",
  "pruefid_removed",
  "unknown",
];

export const PROV_TONE: Record<string, DiffTone> = {
  beide: "added",
  dokument: "modified",
  historie: "neutral",
};

export const PROV_LABEL: Record<string, string> = {
  beide: "Beide",
  dokument: "Dokument",
  historie: "Historie",
};

export const toneOf = (t: string): DiffTone => TYPE_TONE[t] ?? "neutral";

/** Anzeige-ID eines Eintrags: aend_id, sonst doc_diff_id. */
export function entryId(e: ChangelogEntry): string {
  return e.aend_id ?? e.doc_diff_id ?? "";
}

/**
 * Link auf die Original-Quelldatei über die Vite-Middleware `/source-docs` —
 * gibt es nur im Dev-Server. In prod liefert nginx unter dem Pfad die SPA aus,
 * dort also kein Link (null), nur der Dateiname.
 */
export function sourceDocHref(e: ChangelogEntry): string | null {
  if (!import.meta.env.DEV) return null;
  if (!e.source_file) return null;
  const fv = e.formatversion || "";
  const dt = (e.doctype || "").toLowerCase();
  if (!fv || !dt) return null;
  return `/source-docs/${encodeURIComponent(dt)}/${encodeURIComponent(fv)}/${encodeURIComponent(e.source_file)}`;
}
